module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.d7d5d458.ttf";